import { Box, Card, Typography, Grid } from "@mui/material";
import styled from "@mui/material/styles/styled";

// Modern styled components using theme properly
export const HeroSection = styled(Box)(({ theme }) => ({
  background: `linear-gradient(135deg, ${theme.palette.primary.other} 60%, ${theme.palette.primary.light} 100%)`,
  minHeight: "50vh",
  display: "flex",
  alignItems: "center",
  position: "relative",
  overflow: "hidden",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background:
      'url(\'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="50" cy="50" r="1" fill="white" opacity="0.1"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>\')',
    opacity: 0.3,
  },
}));

export const ModernCard = styled(Card)({
  height: "100%",
  borderRadius: "24px",
  background: "rgba(255, 255, 255, 0.95)",
  backdropFilter: "blur(10px)",
  border: "1px solid rgba(255, 255, 255, 0.2)",
  boxShadow: "0 20px 40px rgba(0, 0, 0, 0.1)",
  transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
  cursor: "pointer",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  "&:hover": {
    transform: "translateY(-8px) scale(1.02)",
    boxShadow: "0 32px 64px rgba(0, 0, 0, 0.15)",
    "& .product-image": {
      transform: "scale(1.1)",
    },
    "& .card-overlay": {
      opacity: 1,
    },
  },
});

export const ProductImage = styled(Box)({
  position: "relative",
  height: "300px",
  overflow: "hidden",
  "& .product-image": {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    transition: "transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
  },
});

export const CardOverlay = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: `linear-gradient(135deg, #BAB8B8CC 50%, ${theme.palette.primary.light}CC)`,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  opacity: 0,
  transition: "opacity 0.3s ease",
  "& .overlay-content": {
    textAlign: "center",
    color: "#2C2C2C",
  },
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  background: `linear-gradient(135deg, ${theme.palette.primary.other}, ${theme.palette.secondary.main})`,
  backgroundClip: "text",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  fontWeight: 800,
  letterSpacing: "-0.02em",
  marginBottom: theme.spacing(2),
}));

export const FeatureGrid = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(8),
  marginBottom: theme.spacing(8),
}));

export const FeatureCard = styled(Box)(({ theme }) => ({
  textAlign: "center",
  padding: theme.spacing(4),
  borderRadius: "16px",
  background: "rgba(255, 255, 255, 0.7)",
  backdropFilter: "blur(10px)",
  border: "1px solid rgba(255, 255, 255, 0.2)",
  transition: "all 0.3s ease",
  "&:hover": {
    transform: "translateY(-4px)",
    boxShadow: "0 16px 32px rgba(0, 0, 0, 0.1)",
  },
}));
